import {hasAllPermissions, hasAnyPermission} from '@/utils/permission'

/**
 * 无权限时直接移除操作元素；业务状态导致的不可操作仍由页面保留按钮并显示原因。
 */
export function installPermissionDirective(Vue) {
    Vue.directive('permission', {
        inserted(el, binding) {
            const codes = Array.isArray(binding.value) ? binding.value : [binding.value]
            const allowed = binding.modifiers.all ? hasAllPermissions(codes) : hasAnyPermission(codes)
            if (!allowed && el.parentNode) {
                el.parentNode.removeChild(el)
            }
        },
    })
}
